let language = {

    SHOPIFY_CONNECT_ALREADY_HAVE_ACCOUNT: "You already have an account. Continue with your",
    SHOPIFY_CONNECT_USER_EMAIL: "{{userMail}}",
    SHOPIFY_CONNECT_CONTINUE_BTN: "Continue",
    SHOPIFY_CONNECT_CONNECT_TO_SHOPIFY_TEXT: "Connect {{appName}} to Shopify",
    SHOPIFY_CONNECT_NEW_TO_SITE_TEXT: "New To {{appName}} ?",
    SHOPIFY_CONNECT_SIGNUP_LINK: "Sign Up",
    SHOPIFY_CONNECT_ALREADY_HAVA_ACCOUNT_QUESTION_TEXT: "Already have an account?",
    SHOPIFY_CONNECT_SIGNIN_LINK: "Sign In",
    SHOPIFY_CONNECT_CONFIRM_CONNECTION_TEXT: "Confirm connection",
    SHOPIFY_CONNECT_CONNECT_STORE_TO_USER_TEXT: "Connect store to {{userMail}}",
    SHOPIFY_CONNECT_SIGNIN_DIFFERENT_ACCOUNT: "Sign in a different account",
};

export { language }